<div>
  <form #f="ngForm" novalidate class="formborder">
    <div class="row m-0 col-md-12 align-items-end p-0">
      <div class="col-md-3">
        <span> Insurance Company Name </span>
        <input
          type="text"
          name="Insurance_company"
          [(ngModel)]="Insurance_com"
          class="form-control input-text-css"
        />
      </div>
      <div class="col-md-2" *ngFor="let item of checkboxesDataList">
        <div style="height: 2rem; display: flex; align-items: center; margin-bottom: 0.75rem !important;">
          <input
            type="checkbox"
            [(ngModel)]="item.isChecked"
            id="{{ item.id }}"
            (change)="changeSelection()"
            [ngModelOptions]="{ standalone: true }"
            style="cursor: pointer; width: 1rem; height: 1rem; margin: 0 0.5rem 0 0;"
          />
          <label class="form-check-label" [for]="item.id" style="cursor: pointer; font-size: 0.75rem; margin: 0; line-height: 1; user-select: none;">
            {{ item.InsuranceType }}
          </label>
        </div>
      </div>
      <div class="col-md-2">
        <div style="height: 2rem; display: flex; align-items: center; justify-content: center; margin-bottom: 0.75rem !important;">
          <div class="toggle-button-cover" style="width: 7.5rem; height: 1.875rem;">
            <div class="button-cover" style="position: relative; width: 7.5rem; height: 1.875rem;">
              <div
                id="button-1"
                class="button r"
                style="margin: 0 !important; top: 0 !important; height: 1.875rem; width: 7.5rem;"
              >
                <input
                  type="checkbox"
                  name="FilterStatusId"
                  id="FilterStatusId"
                  class="checkbox"
                  style="cursor: pointer;"
                />
                <div class="knobs"></div>
                <div class="layer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 d-flex justify-content-end">
        <button
          type="button"
          (click)="SaveInsuranceCompany(f)"
          *ngIf="saveBtn"
          class="btn font-size-12 button-btn"
          style="height: 2rem; margin-bottom: 0.75rem !important;"
          [class.spinner]="loading"
          [disabled]="!f.form.valid"
        >
          Save
        </button>
        <button
          type="button"
          (click)="UpdateInsuranceCmpy(f)"
          *ngIf="updateBtn"
          class="btn font-size-12 button-btn"
          style="height: 2rem; margin-bottom: 0.75rem !important;"
          [class.spinner]="loading"
          [disabled]="!f.form.valid"
        >
          Update
        </button>
      </div>
    </div>
  </form>

  <div class="mt-3">
    <div class="">
      <div class="table-responsive">
        <mat-table [dataSource]="GetInsuranceCompany">
          <ng-container matColumnDef="Int_Id">
            <mat-header-cell
              class="grid-header"
              style="max-width: 3.125rem"
              *matHeaderCellDef
            >
              #
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell"
              style="max-width: 3.125rem"
            >
              {{ i + 1 }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Insurance Company">
            <mat-header-cell
              class="grid-header"
              style="max-width: 25rem"
              *matHeaderCellDef
            >
              Insurance Company
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              class="grid-cell"
              style="max-width: 25rem"
            >
              {{ row.Insurance_company }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Insurance Type">
            <mat-header-cell class="grid-header" style="" *matHeaderCellDef>
              Insurance Type
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell" style="">
              {{ row.Insurance_type }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Status">
            <mat-header-cell class="grid-header" style="" *matHeaderCellDef>
              Stauts
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell" style="">
              <p
                *ngIf="row.Status == 1; else elsee"
                [ngStyle]="{ color: 'green' }"
              >
                Active
              </p>
              <ng-template #elsee>
                <p [ngStyle]="{ color: 'red' }">Deactive</p>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Action">
            <mat-header-cell
              class="grid-header j-c-center"
              style=""
              *matHeaderCellDef
            >
              Action
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
              <i
                *ngIf="!inViewMode"
                class="fas fa-lg fa-edit margin-right-4xs cursor-style"
                aria-label="true"
                (click)="editInsuranceCmpy(row)"
              ></i>
              <i
                class="fa fa-trash style-delete"
                (click)="status(row)"
                *ngIf="!inViewMode"
                aria-label="true"
              ></i>
            </mat-cell>
          </ng-container>
          <mat-header-row
            *matHeaderRowDef="displayedCustomerColumns"
          ></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedCustomerColumns"
          ></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
